/**
 * Web Storefront to Native App Container bridge
 * Sends messages to native container app (iOS and Android)
 */
export default function sendMessageToNativeContainer(action, payload) {
    let message;

    try {
        message = JSON.stringify({ action, payload });
    } catch (error) {
        console.error(error);
        return;
    }

    if (Mobi2Go.app.platform === 'android') {
        if (window.ReactNativeWebView) {
            sendMessageToNewApps(message);
        } else {
            try {
                window.postMessage(message, '*');
            } catch (e) {
                if (console && console.error) {
                    console.error(
                        `Unable to send message to Android native container app. ${e.message}`
                    );
                }
            }
        }

        return;
    }

    if (Mobi2Go.app.platform === 'ios') {
        try {
            if (window.webkit.messageHandlers.reactNative) {
                window.webkit.messageHandlers.reactNative.postMessage(message);
            } else {
                sendMessageToNewApps(message);
            }
        } catch (e) {
            if (console && console.error) {
                console.error(
                    `Unable to send message to iOS native container app. ${e.message}`
                );
            }
        }

        return;
    }

    if (console && console.error) {
        console.error(
            'Attempted to send message to native container app in a non-container UI',
            message
        );
    }
}

function sendMessageToNewApps(message) {
    try {
        window.ReactNativeWebView.postMessage(message);
    } catch (e) {
        if (console && console.error) {
            console.error(
                `Unable to send message to native apps. ${e.message}`
            );
        }
    }
}
